import gql from 'graphql-tag'
import { client } from '../utils/GQLClient'
import { customContent } from './__generated__/types'

const CUSTOM_CONTENT_QUERY = gql`
  query customContent($accountId: Int!) {
    customContent(accountId: $accountId) {
      logo
      headline
      content
    }
  }
`

export function getCustomContent(accountId: number) {
  return client.query<customContent>({
    query: CUSTOM_CONTENT_QUERY,
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
    variables: { accountId }
  })
}
